/**
 * efw.public.js - Simple public utilities
 *
 * Adds a "public" class to the body if the page is being served on a public server,
 * or "preview" class if on a staging server. This runtime detection is necessary
 * because the CMS copies the same static files to both preview and public server
 * locations, so we can't rely on build-time configuration.
 */

(function($) {
    'use strict';

    $.fn.efwPublic = function() {
        return this.each(function() {
            var $body = $(this);

            // Check if body has data-export="preview"
            if ($body.data('export') === 'preview') {
                // Check if hostname contains "preview"
                if (window.location.hostname.indexOf('preview') !== -1) {
                    $body.addClass('preview');
                } else {
                    $body.addClass('public');
                }
            }
        });
    };

    /**
     * Rewrite each matched language-switch link to the host for the *current*
     * runtime environment.
     *
     * The link host is baked at publish time to the PUBLIC site (correct for
     * crawlers and no-JS visitors on the public site). But preview2 / preview /
     * public are plain file-copies of one static publish, so on preview2 / preview
     * (and on the edit site) the baked public host is wrong. The language template
     * emits window.__f8LangMap: a base64-encoded { host: sibling-language-host }
     * map for this site. We look up the actual current hostname and swap only the
     * host on each link, leaving the baked path/query intact.
     *
     * On the public site the lookup resolves to the public sibling (a no-op), so no
     * preview host is ever promoted into a link there.
     */
    $.fn.efwLangSwitch = function() {
        if (!window.__f8LangMap) {
            return this;
        }

        var map;
        try {
            map = JSON.parse(atob(window.__f8LangMap));
        } catch (e) {
            return this;
        }

        var target = map[window.location.hostname];
        if (!target) {
            return this; // unknown host: leave the baked public link as-is
        }

        return this.each(function() {
            this.host = target; // swap host only; keep path + query
        });
    };

    // Initialize on document ready
    $(document).ready(function() {
        $('body').efwPublic();
        $('a.styleLanguageJump, a.lang-toggle-item').efwLangSwitch();
    });

})(jQuery);